import React from 'react';
import { History } from 'history';
import { Input, InputMoney, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './transactionamount-model';  //editable..

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class TransactionamountDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} readOnly/>
                <InputPicklist name='transaction' label='Transaction' value={this.state.datarow.transaction} caption={this.state.datarow.transactionCaption} readOnly/>
                <InputPicklist name='amounttype' label='Type' value={this.state.datarow.amounttype} caption={this.state.datarow.amounttypeCaption} readOnly/>
                <InputMoney name='value' label='Amount' value={this.state.datarow.value} readOnly/>
                
              </BaseDelete>
        );
    }
}